import {
  CardSection,
  DisplayAd,
  GroupType,
  SectionType,
} from '../generated/types';
import {createDisplayAdItem} from './DisplayAdItem';

export function createDisplayAdSection({
  layoutId,
  displayAd,
}: {
  layoutId: string;
  displayAd: DisplayAd;
}): CardSection {
  const sectionId = `${layoutId}-section-display-ad`;
  return {
    id: sectionId,
    type: SectionType.DisplayAd,
    groups: [
      {
        id: `${sectionId}-group-display-ad`,
        type: GroupType.DisplayAd,
        items: displayAd ? [createDisplayAdItem(displayAd)] : [],
      },
    ],
  };
}
